import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableRowColumn } from 'material-ui/Table';

const SystemTaskJobRow = ({row, children, ...others}) => {
    const dateScheduled = row.schedule && (row.schedule.replace("T", " "));
    const dateStarted = row.start && (row.start.replace("T", " "));
    const dateFinished = row.finish && (row.finish.replace("T", " "));
    others.className = `${others.className || ''} task-job-${row.status}`;

    return (
        <TableRow {...others} >
            {children && children[0]}
            <TableRowColumn>{dateScheduled}</TableRowColumn>
            <TableRowColumn>{dateStarted}</TableRowColumn>
            <TableRowColumn>{dateFinished}</TableRowColumn>
            <TableRowColumn>{row.status}</TableRowColumn>
            {others.withAuto && (
                <TableRowColumn>{row.auto ? "Yes" : "No"}</TableRowColumn>
            )}
        </TableRow>
    );
};

SystemTaskJobRow.propTypes = {
    row:        PropTypes.shape({
        id:         PropTypes.number.isRequired,
    }),
    withAuto:   PropTypes.bool
};

SystemTaskJobRow.defaultProps = {
    withAuto: true
}

export default SystemTaskJobRow;
